import { Component, ViewChild, OnInit } from '@angular/core';
import { Chart } from 'chart.js';
import { Apollo } from 'apollo-angular';
/* import ChartDataLabels from 'chartjs-plugin-datalabels'; */
//ROUTE
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
//servicios
import { ClienteService } from 'src/app/services/cliente.service';
import { LoginService } from 'src/app/services/login.service';
import { DocumentoService } from 'src/app/services/documento.service';
import { TransportistaService } from 'src/app/services/transportista.service';
import { GestorService } from 'src/app/services/gestor.service';
import { CentroService } from 'src/app/services/centro.service';
import { ContratistaService } from 'src/app/services/contratista.service';
import { runInThisContext } from 'vm';
import { InstalacionService } from 'src/app/services/instalacion.service';
import { DocAdicionalService } from 'src/app/services/doc-adicional.service';

@Component({
  selector: 'app-inicio-entidades-cliente',
  templateUrl: './inicio-entidades-cliente.component.html',
  styleUrls: ['./inicio-entidades-cliente.component.scss']
})
export class InicioEntidadesClienteComponent implements OnInit {
  public id: any;
  public params?: any

  @ViewChild('doughnutCanvasInstalaciones') doughnutCanvasInstalaciones: any;
  @ViewChild('doughnutCanvasCentros') doughnutCanvasCentros: any;
  @ViewChild('doughnutCanvasAdicOneCentros') doughnutCanvasAdicOneCentros: any;
  @ViewChild('doughnutCanvasAdicTwoCentros') doughnutCanvasAdicTwoCentros: any;
  @ViewChild('doughnutCanvasAdicThrCentros') doughnutCanvasAdicThrCentros: any;
  /* @ViewChild('doughnutCanvasClientes') doughnutCanvasClientes: any; */
  @ViewChild('doughnutCanvasContratistas') doughnutCanvasContratistas: any;
  @ViewChild('doughnutCanvasGestores') doughnutCanvasGestores: any;
  @ViewChild('doughnutCanvasTransportistas') doughnutCanvasTransportistas: any;


  title_instalaciones = 'Instalaciones';
  title_centros = 'Centros';
  /*  title_clientes = 'Clientes'; */
  title_contratistas = 'Contratistas';
  title_gestores = 'Gestores';
  title_transportistas = 'Transportistas';

  barChart: any;
  doughnutChart: any;
  lineChart: any;
  doughnutChartInstalaciones: any;
  doughnutChartCentros: any;
  doughnutChartAdicOneCentros: any;
  doughnutChartAdicTwoCentros: any;
  doughnutChartAdicThrCentros: any;
  /* doughnutChartClientes: any; */
  doughnutChartContratistas: any;
  doughnutChartGestores: any;
  doughnutChartTransportistas: any;

  public cliente: any;
  public basica: any
  public userLogged: any
  public loading: any

  //Transportistas
  idTransportistaCliente: any = []
  transportistaCliente: any
  transportistasRojos: any = []
  transportistasVerdes: any = []
  transportistasAmarillos: any = []

  //Gestores
  idGestorCliente: any = []
  gestoresCliente: any
  gestoresRojos: any = []
  gestoresVerdes: any = []
  gestoresAmarillos: any = []

  //Centros
  idCentrosCliente: any = []
  centroCliente: any
  centrosRojos: any = []
  centrosVerdes: any = []
  centrosAmarillos: any = []

  //Contratistas
  idContratistasCliente: any = []
  contratistaCliente: any
  contratistasRojos: any = []
  contratistasVerdes: any = []
  contratistasAmarillos: any = []

  //Instalaciones
  idInstalacionesCliente: any = []
  instalacionCliente: any
  instalacionesRojos: any = []
  instalacionesVerdes: any = []
  instalacionesAmarillos: any = []

  nombreArchivoOne: any
  nombreArchivoTwo: any
  nombreArchivoThr: any


  constructor(private route: ActivatedRoute, private apollo: Apollo,
    private loginService: LoginService, private documentoService: DocumentoService,
    private clienteService: ClienteService, private transportistaService: TransportistaService,
    private gestorService: GestorService, private centroService: CentroService,
    private contratistaService: ContratistaService, private router: Router,
    private instalacionService: InstalacionService, private docAdicService: DocAdicionalService) {

    this.userLogged = this.loginService.getUserData()

  }

  ngOnInit(): void {
    this.getClienteById()
  }



  ngAfterViewInit() {

    this.getTransportistasByCliente();
    this.getGestoresByCliente()
    this.getCentrosByCliente()
    this.getConstratistasByCliente()
    this.getInstalacionesByCliente()
    this.getDocumentosByCliente()

  }

  validarUltimoEstado(data: any) {
    let result = data.map((item: any) => {
      let docsRojos = item.documentos.filter((doc: any) => (doc.tipo === 'activo' || doc.tipo === 'enEspera') && doc.estado === "rojo");
      let docsAmarillos = item.documentos.filter((doc: any) => (doc.tipo === 'activo' || doc.tipo === 'enEspera') && doc.estado === "amarillo");
      let docsVerdes = item.documentos.filter((doc: any) => (doc.tipo === 'activo' || doc.tipo === 'enEspera') && doc.estado === "verde");
      if (docsRojos.length > 0)
        return {
          id: item.id,
          estado: "rojo"
        }
      else if (docsAmarillos.length > 0 && docsRojos.length === 0)
        return {
          id: item.id,
          estado: "amarillo"
        }
      else if (docsVerdes.length > 0 && docsAmarillos.length === 0 && docsRojos.length === 0)
        return {
          id: item.id,
          estado: "verde"
        }
      else {
        return {
          id: item.id,
          estado: "rojo"
        }
      }
    })
    return result;
  }

  checkUltimoEstado(data: any) {
    data.forEach((item: any) => {
      let filtrados = item.documentos.filter((doc: any) => doc.tipo === "activo" || doc.tipo === "enEspera");
      let rojos = filtrados.some((r: any) => r.estado === "rojo");
      let amarillos = filtrados.some((y: any) => y.estado === "amarillo");
      let verdes = filtrados.some((g: any) => g.estado === "verde");
      if (rojos)
        item.estado = "rojo"
      else if (amarillos && !rojos)
        item.estado = "amarillo"
      else if (verdes && !amarillos && !rojos)
        item.estado = "verde"
    })
  }

  checkTiposDocumentos(data: any[], obj: any) {
    let reds = data.some((i: any) => i.estado === "rojo")
    let yellows = data.some((i: any) => i.estado === "amarillo")
    let greens = data.some((i: any) => i.estado === "verde")
    if (reds)
      obj.estado = "rojo"
    else if (yellows && !reds)
      obj.estado = "amarillo"
    else if (greens && !yellows && !reds)
      obj.estado = "verde"
  }

  getDocumentosByCliente() {

    this.apollo.watchQuery<any>({
      query: this.clienteService.getClienteById(),
      fetchPolicy: "no-cache",
      variables: {
        id: this.userLogged.cliente.id
      }
    })
      .valueChanges
      .subscribe(({ data, loading, errors }) => {
        //console.log(data);
        const docAdicOne = data.cliente.documentos_adicionals.filter((doc: any) => doc.firstTime != true && doc.numArchivo == 1 && doc.tipo === 'activo' || doc.tipo === 'enEspera')
        const docAdicTwo = data.cliente.documentos_adicionals.filter((doc: any) => doc.firstTime != true && doc.numArchivo == 2 && doc.tipo === 'activo' || doc.tipo === 'enEspera')
        const docAdicThr = data.cliente.documentos_adicionals.filter((doc: any) => doc.firstTime != true && doc.numArchivo == 3 && doc.tipo === 'activo' || doc.tipo === 'enEspera')


        if (docAdicOne.length > 0) {
          this.nombreArchivoOne = docAdicOne[0].nombreArchivo
          //console.log(docAdicOne)
          let docRojo = docAdicOne.filter((doc: any) => doc.estado == 'rojo');
          let docAmarillo = docAdicOne.filter((doc: any) => doc.estado == 'amarillo');
          let docVerde = docAdicOne.filter((doc: any) => doc.estado == 'verde')
          //console.log(Object.keys(docVerde).length, Object.keys(docRojo).length, Object.keys(docAmarillo).length)
          setTimeout(() => {
            this.doughnutChartAdicOneCentrosMethod(Object.keys(docVerde).length, Object.keys(docAmarillo).length, Object.keys(docRojo).length)
          }, 300);
        }
        if (docAdicTwo.length > 0) {
          this.nombreArchivoTwo = docAdicTwo[0].nombreArchivo
          let docRojo = docAdicTwo.filter((doc: any) => doc.estado == 'rojo');
          let docAmarillo = docAdicTwo.filter((doc: any) => doc.estado == 'amarillo');
          let docVerde = docAdicTwo.filter((doc: any) => doc.estado == 'verde')
          setTimeout(() => {
            this.doughnutChartAdicTwoCentrosMethod(Object.keys(docVerde).length, Object.keys(docAmarillo).length, Object.keys(docRojo).length)
          }, 300);
        }
        if (docAdicThr.length > 0) {
          this.nombreArchivoThr = docAdicThr[0].nombreArchivo
          let docRojo = docAdicThr.filter((doc: any) => doc.estado == 'rojo');
          let docAmarillo = docAdicThr.filter((doc: any) => doc.estado == 'amarillo');
          let docVerde = docAdicThr.filter((doc: any) => doc.estado == 'verde')
          setTimeout(() => {
            this.doughnutChartAdicThrCentrosMethod(Object.keys(docVerde).length, Object.keys(docAmarillo).length, Object.keys(docRojo).length)
          }, 300);
        }
      })

  }

  doughnutChartAdicOneCentrosMethod(fecha: any, proximo: any, caducado: any) {
    const data = [fecha, proximo, caducado]
    this.doughnutChartAdicOneCentros = new Chart(this.doughnutCanvasAdicOneCentros.nativeElement, {
      type: 'doughnut',

      data: {
        labels: ['Correcto', 'Próximo a caducar', 'Caducado'],
        datasets: [{
          label: 'Estados',
          data: data,
          backgroundColor: [
            '#00A131',
            '#FF9E00',
            '#DC3737'

          ],
          hoverBackgroundColor: [
            '#308F70',
            '#EDB355',
            '#EE5B5B'
          ]
        }]
      },
      options: {
        legend: {
          display: false
        }
      }
    });
  }

  doughnutChartAdicTwoCentrosMethod(fecha: any, proximo: any, caducado: any) {
    const data = [fecha, proximo, caducado]
    this.doughnutChartAdicTwoCentros = new Chart(this.doughnutCanvasAdicTwoCentros.nativeElement, {
      type: 'doughnut',

      data: {
        labels: ['Correcto', 'Próximo a caducar', 'Caducado'],
        datasets: [{
          label: 'Estados',
          data: data,
          backgroundColor: [
            '#00A131',
            '#FF9E00',
            '#DC3737'

          ],
          hoverBackgroundColor: [
            '#308F70',
            '#EDB355',
            '#EE5B5B'
          ]
        }]
      },
      options: {
        legend: {
          display: false
        }
      }
    });
  }

  doughnutChartAdicThrCentrosMethod(fecha: any, proximo: any, caducado: any) {
    const data = [fecha, proximo, caducado]
    this.doughnutChartAdicThrCentros = new Chart(this.doughnutCanvasAdicThrCentros.nativeElement, {
      type: 'doughnut',

      data: {
        labels: ['Correcto', 'Próximo a caducar', 'Caducado'],
        datasets: [{
          label: 'Estados',
          data: data,
          backgroundColor: [
            '#00A131',
            '#FF9E00',
            '#DC3737'

          ],
          hoverBackgroundColor: [
            '#308F70',
            '#EDB355',
            '#EE5B5B'
          ]
        }]
      },
      options: {
        legend: {
          display: false
        }
      }
    });
  }

  getClienteById(): void {
    this.apollo.watchQuery<any>({
      query: this.clienteService.getClienteById(),
      variables: {
        "id": this.userLogged.cliente.id
      }
    })
      .valueChanges
      .subscribe(({ data, loading, errors }) => {
        this.basica = data.cliente?.xtensaBasica
        this.loading = loading
      }, (error) => {
        console.log('aaaaa', error)
      })
  }

  getTransportistasByCliente() {
    this.apollo.watchQuery<any>({
      query: this.clienteService.getCentrosByCliente(),
      fetchPolicy: "no-cache",
      variables: {
        "id": this.userLogged.cliente.id
      }
    })
      .valueChanges
      .subscribe(({ data, loading, errors }) => {
        const centros = data.cliente.centros
        let transportistas: any = []

        centros.forEach((centro: any) => {
          centro.transportistas.forEach((transportista: any) => {
            transportistas.push(transportista)
          });
        });

        let hash: any = {};
        transportistas = transportistas.filter(function (current: any) {
          let exists = !hash[current.id];
          hash[current.id] = true;
          return exists;
        });
        //console.log(transportistas)
        let checkUltimoEstado = this.validarUltimoEstado(transportistas)
        checkUltimoEstado.forEach((transportista: any) => {

          switch (transportista.estado) {
            case 'rojo':
              this.transportistasRojos.push(transportista)

              break;
            case 'amarillo':
              this.transportistasAmarillos.push(transportista)

              break;
            case 'verde':
              this.transportistasVerdes.push(transportista)

              break;

          }

        });
        this.doughnutChartTransportistasMethod()
      }
      )
  }

  getGestoresByCliente() {
    this.apollo.watchQuery<any>({
      query: this.clienteService.getCentrosByCliente(),
      fetchPolicy: "no-cache",
      variables: {
        "id": this.userLogged.cliente.id
      }
    })
      .valueChanges
      .subscribe(({ data, loading, errors }) => {

        const centros = data.cliente.centros
        let gestores: any = []

        centros.forEach((centro: any) => {
          centro.gestors.forEach((gestor: any) => {
            gestores.push(gestor)
          });
        });

        let hash: any = {};
        gestores = gestores.filter(function (current: any) {
          let exists = !hash[current.id];
          hash[current.id] = true;
          return exists;
        });
        let checkUltimoEstado = this.validarUltimoEstado(gestores)
        checkUltimoEstado.forEach((gestor: any) => {

          switch (gestor.estado) {
            case 'rojo':
              this.gestoresRojos.push(gestor)

              break;
            case 'amarillo':
              this.gestoresAmarillos.push(gestor)

              break;
            case 'verde':
              this.gestoresVerdes.push(gestor)

              break;

          }

        });
        this.doughnutChartGestoresMethod()
      }
      )
  }

  getCentrosByCliente() {
    this.apollo.watchQuery<any>({
      query: this.clienteService.getCentrosByClienteDoughnout(),
      fetchPolicy: "no-cache",
      variables: {
        "id": this.userLogged.cliente.id
      }
    })
      .valueChanges
      .subscribe(({ data, loading, errors }) => {
        const centroCliente = data.cliente.centros
        centroCliente?.forEach((centro: any) => {
          let filtrados = centro.documentos.filter((doc: any) =>
            doc.tipo === "activo" || doc.tipo === "esEspera"
          )
          if (filtrados.length === 0) {
            centro.estado = "rojo"
          } else {
            let hasDocAmarillo = filtrados.some((cent: any) => cent.estado === "amarillo")
              if (hasDocAmarillo){
                centro.estado = "amarillo"
              }
            let hasDocsRojo = filtrados.some((cent: any) => cent.estado === "rojo")
            if (!hasDocsRojo && !hasDocAmarillo) {
              this.checkUltimoEstado(centro.gestors)
              this.checkUltimoEstado(centro.transportistas)
              let allCondicion = [...centro.gestors, ...centro.transportistas]
              this.checkTiposDocumentos(allCondicion, centro)
            } else if (hasDocsRojo){
              centro.estado = "rojo"
            }
          }
          switch (centro.estado) {
            case 'rojo':
              this.centrosRojos.push(centro)

              break;
            case 'amarillo':
              this.centrosAmarillos.push(centro)
              break;
            case 'verde':
              this.centrosVerdes.push(centro)
              break
          }
        });
        this.doughnutChartCentrosMethod()
      }
      )
  }

  updateCentroById(id: any, estado: any) {
    this.apollo.mutate({
      mutation: this.centroService.updateCentro(),
      variables: {
        "input": {
          "where": {
            "id": id
          },
          "data": {
            "estado": estado
          }
        }
      }
    })
      .subscribe(({ data, errors }) => {

      }, (error) => {
        console.log('aaaaa', error)
      })
  }


  getConstratistasByCliente() {
    this.apollo.watchQuery<any>({
      query: this.clienteService.getContratistasByClienteDoughnout(),
      fetchPolicy: "no-cache",
      variables: {
        "id": this.userLogged.cliente.id
      }
    })
      .valueChanges
      .subscribe(({ data, loading, errors }) => {
        this.contratistaCliente = data.cliente.contratistas
        this.contratistaCliente?.forEach((contratista: any) => {
          let filtrados = contratista.documentos.filter((doc: any) => doc.tipo === 'activo'
            || doc.tipo === 'enEspera'
            || doc.tipo === 'seguridadSocialActivoEnEspera'
            || doc.tipo === 'seguridadSocialActivo'
            || doc.tipo === 'haciendaActivo'
            || doc.tipo === 'haciendaActivoEnEspera')
          if (filtrados.length === 0){
            contratista.estado = "rojo"
          }
          else {
            this.checkTiposDocumentos(filtrados, contratista)
            let hasDocumentosAmarillos = filtrados.some((cent: any) => cent.estado === "amarillo")
            if (hasDocumentosAmarillos){
              contratista.estado = "amarillo"
            }
            let hasDocumentosRojos = filtrados.some((cent: any) => cent.estado === "rojo")
            
            if (!hasDocumentosRojos && !hasDocumentosAmarillos) {
              //chequear documentos de centro
              contratista.centros.forEach((centro: any) => {
                let filtradosCentro = centro.documentos.filter((doc: any) =>
                  doc.tipo === "activo" || doc.tipo === "esEspera"
                )
                if (filtradosCentro.length === 0) {
                  centro.estado = "rojo"
                } else {
                  
                  let hasDocsRojo = filtradosCentro.some((cent: any) => cent.estado === "rojo")
                  if (!hasDocsRojo) {
                    this.checkUltimoEstado(centro.gestors)
                    this.checkUltimoEstado(centro.transportistas)
                    let gestoresYTransp = [...centro.gestors, ...centro.transportistas];
                    this.checkTiposDocumentos(gestoresYTransp, centro)
                  } else {
                    centro.estado = "rojo"
                  }
                }
              })
              this.checkTiposDocumentos(contratista.centros, contratista)
            } else if (hasDocumentosRojos){
              contratista.estado = "rojo"
            }
          }
          
          switch (contratista.estado) {
            case 'rojo':
              this.contratistasRojos.push(contratista)
              break;
            case 'amarillo':
              this.contratistasAmarillos.push(contratista)
              break;
            case 'verde':
              this.contratistasVerdes.push(contratista)
              break;
          }
        });

        this.doughnutChartContratistasMethod()
      }
      )
  }



  getInstalacionesByCliente() {
    this.apollo.watchQuery<any>({
      query: this.clienteService.getInstalacionesByCliente(),
      fetchPolicy: "no-cache",
      variables: {
        "id": this.userLogged.cliente.id
      }
    })
      .valueChanges
      .subscribe(({ data, loading, errors }) => {
        const instalaciones = data.cliente.instalaciones
        instalaciones.forEach((instalacion: any) => {
          let filtrados = instalacion.centro.documentos.filter((doc: any) =>
            doc.tipo === "activo" || doc.tipo === "esEspera"
          )
          if (filtrados.length === 0) {
            instalacion.centro.estado = "rojo"
          } else {
            let hasDocAmarillo = filtrados.some((cent: any) => cent.estado === "amarillo")
              if (hasDocAmarillo){
                instalacion.centro.estado = "amarillo"
              }

            let hasDocsRojos = filtrados.some((cent: any) => cent.estado === "rojo")
            if (!hasDocsRojos && !hasDocAmarillo) {
              this.checkUltimoEstado(instalacion.centro.gestors)
              this.checkUltimoEstado(instalacion.centro.transportistas)
              let transpYGestores = [...instalacion.centro.transportistas, ...instalacion.centro.gestors]
              this.checkTiposDocumentos(transpYGestores, instalacion.centro)
            } else if (hasDocsRojos){
              instalacion.centro.estado = "rojo"
            }
          }
          switch (instalacion?.centro?.estado) {
            case 'rojo':
              this.instalacionesRojos.push(instalacion.centro)
              break;
            case 'amarillo':
              this.instalacionesAmarillos.push(instalacion.centro)
              break;
            case 'verde':
              this.instalacionesVerdes.push(instalacion.centro)
              break;
            default:
              break;
          }
        });
        this.doughnutChartInstalacionesMethod()
      }
      )
  }








  doughnutChartInstalacionesMethod() {
    const data = [this.instalacionesVerdes.length, this.instalacionesAmarillos.length, this.instalacionesRojos.length]
    this.doughnutChartInstalaciones = new Chart(this.doughnutCanvasInstalaciones.nativeElement, {
      type: 'doughnut',

      data: {
        labels: ['Correcto', 'Próximo a caducar', 'Caducado'],
        datasets: [{
          label: 'Estados',
          data: data,
          backgroundColor: [
            '#00A131',
            '#FF9E00',
            '#DC3737'

          ],
          hoverBackgroundColor: [
            '#308F70',
            '#EDB355',
            '#EE5B5B'
          ]
        }]
      }
    });
  }

  doughnutChartCentrosMethod() {
    const data = [this.centrosVerdes.length, this.centrosAmarillos.length, this.centrosRojos.length]
    this.doughnutChartCentros = new Chart(this.doughnutCanvasCentros.nativeElement, {
      type: 'doughnut',

      data: {
        labels: ['Correcto', 'Próximo a caducar', 'Caducado'],
        datasets: [{
          label: 'Estados',
          data: data,
          backgroundColor: [
            '#00A131',
            '#FF9E00',
            '#DC3737'

          ],
          hoverBackgroundColor: [
            '#308F70',
            '#EDB355',
            '#EE5B5B'
          ]
        }]
      }
    });
  }

  doughnutChartContratistasMethod() {
    const data = [this.contratistasVerdes.length, this.contratistasAmarillos.length, this.contratistasRojos.length]

    this.doughnutChartContratistas = new Chart(this.doughnutCanvasContratistas.nativeElement, {
      type: 'doughnut',

      data: {
        labels: ['Correcto', 'Próximo a caducar', 'Caducado'],
        datasets: [{
          label: 'Estados',
          data: data,
          backgroundColor: [
            '#00A131',
            '#FF9E00',
            '#DC3737'

          ],
          hoverBackgroundColor: [
            '#308F70',
            '#EDB355',
            '#EE5B5B'
          ]
        }]
      }
    });
  }

  doughnutChartGestoresMethod() {
    const data = [this.gestoresVerdes.length, this.gestoresAmarillos.length, this.gestoresRojos.length]


    this.doughnutChartGestores = new Chart(this.doughnutCanvasGestores.nativeElement, {
      type: 'doughnut',

      data: {
        labels: ['Correcto', 'Próximo a caducar', 'Caducado'],
        datasets: [{
          label: 'Estados',
          data: data,

          backgroundColor: [
            '#00A131',
            '#FF9E00',
            '#DC3737'

          ],
          hoverBackgroundColor: [
            '#308F70',
            '#EDB355',
            '#EE5B5B'
          ]
        }]
      }
    });
  }

  doughnutChartTransportistasMethod() {
    const data = [this.transportistasVerdes.length, this.transportistasAmarillos.length, this.transportistasRojos.length]
    this.doughnutChartTransportistas = new Chart(this.doughnutCanvasTransportistas.nativeElement, {
      type: 'doughnut',

      data: {
        labels: ['Correcto', 'Próximo a caducar', 'Caducado'],
        datasets: [{
          label: 'Estados',
          data: data,
          backgroundColor: [
            '#00A131',
            '#FF9E00',
            '#DC3737'

          ],
          hoverBackgroundColor: [
            '#308F70',
            '#EDB355',
            '#EE5B5B'
          ]
        }]
      }
    });
  }

  showDataGestores(evt: any) {
    let data = this.doughnutChartGestores.getElementsAtEvent(evt)
    //console.log(data[0]._model);
    switch (data[0]._model.backgroundColor) {
      case '#308F70':
        this.filterGreenGestor()
        break;
      case '#EDB355':
        this.filterYellowGestor()
        break;
      case '#EE5B5B':
        this.filterRedGestor()
        break;

      default:
        break;
    }

  }

  showDataTransportistas(evt: any) {
    let data = this.doughnutChartTransportistas.getElementsAtEvent(evt)

    // console.log(data[0]._model.backgroundColor)
    switch (data[0]._model.backgroundColor) {
      case '#308F70':
        this.filterGreenTransportistas()
        break;
      case '#EDB355':
        this.filterYellowTransportistas()
        break;
      case '#EE5B5B':
        this.filterRedTransportistas()
        break;

      default:
        break;
    }

  }

  showDataCentros(evt: any) {
    let data = this.doughnutChartCentros.getElementsAtEvent(evt)
    //console.log(data[0]._model);
    switch (data[0]._model.backgroundColor) {
      case '#308F70':
        this.filterGreenCentros()
        break;
      case '#EDB355':
        this.filterYellowCentros()
        break;
      case '#EE5B5B':
        this.filterRedCentros()
        break;

      default:
        break;
    }

  }

  showDataContratistas(evt: any) {
    let data = this.doughnutChartContratistas.getElementsAtEvent(evt)
    //console.log(data[0]._model);
    switch (data[0]._model.backgroundColor) {
      case '#308F70':
        this.filterGreenContratistas()
        break;
      case '#EDB355':
        this.filterYellowContratistas()
        break;
      case '#EE5B5B':
        this.filterRedContratistas()
        break;

      default:
        break;
    }

  }

  showDataInstalaciones(evt: any) {
    let data = this.doughnutChartInstalaciones.getElementsAtEvent(evt)
    //console.log(data[0]._model);
    switch (data[0]._model.backgroundColor) {
      case '#308F70':
        this.filterGreenInstalaciones()
        break;
      case '#EDB355':
        this.filterYellowInstalaciones()
        break;
      case '#EE5B5B':
        this.filterRedInstalaciones()
        break;

      default:
        break;
    }

  }

  filterYellowGestor() {

    this.apollo.watchQuery<any>({
      query: this.clienteService.getCentrosByCliente(),
      variables: {
        "id": this.userLogged.cliente.id
      }
    })
      .valueChanges
      .subscribe(({ data, loading, errors }) => {
        let centros = data.cliente.centros
        let gestores: any = []

        centros.forEach((centro: any) => {
          centro.gestors.forEach((gestor: any) => {
            gestores.push(gestor)
          });
        });

        let hash: any = {};
        gestores = gestores.filter(function (current: any) {
          let exists = !hash[current.id];
          hash[current.id] = true;
          return exists;
        });
        gestores = gestores.filter((gestor: any) => gestor.estado == 'amarillo')
        this.gestorService.setGestores(gestores)
        this.router.navigate(['/cliente/gestores']);
      })

  }

  filterGreenGestor() {

    this.apollo.watchQuery<any>({
      query: this.clienteService.getCentrosByCliente(),
      variables: {
        "id": this.userLogged.cliente.id
      }
    })
      .valueChanges
      .subscribe(({ data, loading, errors }) => {
        let centros = data.cliente.centros
        let gestores: any = []

        centros.forEach((centro: any) => {
          centro.gestors.forEach((gestor: any) => {
            gestores.push(gestor)
          });
        });

        let hash: any = {};
        gestores = gestores.filter(function (current: any) {
          let exists = !hash[current.id];
          hash[current.id] = true;
          return exists;
        });
        gestores = gestores.filter((gestor: any) => gestor.estado == 'verde')
        this.gestorService.setGestores(gestores)
        this.router.navigate(['/cliente/gestores']);
      })

  }

  filterRedGestor() {

    this.apollo.watchQuery<any>({
      query: this.clienteService.getCentrosByCliente(),
      variables: {
        "id": this.userLogged.cliente.id
      }
    })
      .valueChanges
      .subscribe(({ data, loading, errors }) => {
        let centros = data.cliente.centros
        let gestores: any = []

        centros.forEach((centro: any) => {
          centro.gestors.forEach((gestor: any) => {
            gestores.push(gestor)
          });
        });

        let hash: any = {};
        gestores = gestores.filter(function (current: any) {
          let exists = !hash[current.id];
          hash[current.id] = true;
          return exists;
        });
        gestores = gestores.filter((gestor: any) => gestor.estado == 'rojo')
        this.gestorService.setGestores(gestores)
        this.router.navigate(['/cliente/gestores']);
      })

  }

  filterYellowTransportistas() {

    this.apollo.watchQuery<any>({
      query: this.clienteService.getCentrosByCliente(),
      variables: {
        "id": this.userLogged.cliente.id
      }
    })
      .valueChanges
      .subscribe(({ data, loading, errors }) => {
        let centros = data.cliente.centros
        let transportistas: any = []

        centros.forEach((centro: any) => {
          centro.transportistas.forEach((transportista: any) => {
            transportistas.push(transportista)
          });
        });

        let hash: any = {};
        transportistas = transportistas.filter(function (current: any) {
          let exists = !hash[current.id];
          hash[current.id] = true;
          return exists;
        });
        transportistas = transportistas.filter((transportista: any) => transportista.estado == 'amarillo')
        this.transportistaService.setTransportistas(transportistas)
        this.router.navigate(['/cliente/transportista']);
      })
  }

  filterGreenTransportistas() {

    this.apollo.watchQuery<any>({
      query: this.clienteService.getCentrosByCliente(),
      variables: {
        "id": this.userLogged.cliente.id
      }
    })
      .valueChanges
      .subscribe(({ data, loading, errors }) => {
        let centros = data.cliente.centros
        let transportistas: any = []

        centros.forEach((centro: any) => {
          centro.transportistas.forEach((transportista: any) => {
            transportistas.push(transportista)
          });
        });

        let hash: any = {};
        transportistas = transportistas.filter(function (current: any) {
          let exists = !hash[current.id];
          hash[current.id] = true;
          return exists;
        });
        transportistas = transportistas.filter((transportista: any) => transportista.estado == 'verde')
        this.transportistaService.setTransportistas(transportistas)
        this.router.navigate(['/cliente/transportista']);
      })

  }

  filterRedTransportistas() {

    this.apollo.watchQuery<any>({
      query: this.clienteService.getCentrosByCliente(),
      variables: {
        "id": this.userLogged.cliente.id
      }
    })
      .valueChanges
      .subscribe(({ data, loading, errors }) => {
        let centros = data.cliente.centros
        let transportistas: any = []

        centros.forEach((centro: any) => {
          centro.transportistas.forEach((transportista: any) => {
            transportistas.push(transportista)
          });
        });

        let hash: any = {};
        transportistas = transportistas.filter(function (current: any) {
          let exists = !hash[current.id];
          hash[current.id] = true;
          return exists;
        });
        transportistas = transportistas.filter((transportista: any) => transportista.estado == 'rojo')


        this.transportistaService.setTransportistas(transportistas)
        this.router.navigate(['/cliente/transportista']);
      })

  }

  filterYellowCentros() {

    this.apollo.watchQuery<any>({
      query: this.clienteService.getCentrosYellowCliente(),
      variables: {
        "id": this.userLogged.cliente.id
      }
    })
      .valueChanges
      .subscribe(({ data, loading, errors }) => {
        this.centroService.setCentros(data.cliente.centros)
        this.router.navigate(['/cliente/centros']);
      })
  }

  filterGreenCentros() {

    this.apollo.watchQuery<any>({
      query: this.clienteService.getCentrosGreenCliente(),
      variables: {
        "id": this.userLogged.cliente.id
      }
    })
      .valueChanges
      .subscribe(({ data, loading, errors }) => {
        this.centroService.setCentros(data.cliente.centros)
        this.router.navigate(['/cliente/centros']);
      })

  }

  filterRedCentros() {

    this.apollo.watchQuery<any>({
      query: this.clienteService.getCentrosRedCliente(),
      variables: {
        "id": this.userLogged.cliente.id
      }
    })
      .valueChanges
      .subscribe(({ data, loading, errors }) => {
        this.centroService.setCentros(data.cliente.centros)
        this.router.navigate(['/cliente/centros']);
      })
  }

  filterYellowContratistas() {

    this.apollo.watchQuery<any>({
      query: this.clienteService.getContratistasYellowCliente(),
      variables: {
        "id": this.userLogged.cliente.id
      }
    })
      .valueChanges
      .subscribe(({ data, loading, errors }) => {
        this.contratistaService.setContratistas(data.cliente.contratistas)
        this.router.navigate(['/cliente/contratistas']);
      })
  }

  filterGreenContratistas() {

    this.apollo.watchQuery<any>({
      query: this.clienteService.getContratistasGreenCliente(),
      variables: {
        "id": this.userLogged.cliente.id
      }
    })
      .valueChanges
      .subscribe(({ data, loading, errors }) => {
        this.contratistaService.setContratistas(data.cliente.contratistas)
        this.router.navigate(['/cliente/contratistas']);
      })

  }

  filterRedContratistas() {

    this.apollo.watchQuery<any>({
      query: this.clienteService.getContratistasRedCliente(),
      variables: {
        "id": this.userLogged.cliente.id
      }
    })
      .valueChanges
      .subscribe(({ data, loading, errors }) => {
        this.contratistaService.setContratistas(data.cliente.contratistas)
        this.router.navigate(['/cliente/contratistas']);
      })
  }

  filterYellowInstalaciones() {

    this.apollo.watchQuery<any>({
      query: this.clienteService.getInstalacionesYellowCliente(),
      variables: {
        "id": this.userLogged.cliente.id
      }
    })
      .valueChanges
      .subscribe(({ data, loading, errors }) => {
        this.instalacionService.setInstalaciones(data.cliente.instalaciones)
        this.router.navigate(['/cliente/instalaciones']);
      })
  }

  filterGreenInstalaciones() {

    this.apollo.watchQuery<any>({
      query: this.clienteService.getInstalacionesGreenCliente(),
      variables: {
        "id": this.userLogged.cliente.id
      }
    })
      .valueChanges
      .subscribe(({ data, loading, errors }) => {
        this.instalacionService.setInstalaciones(data.cliente.instalaciones)
        this.router.navigate(['/cliente/instalaciones']);
      })

  }

  filterRedInstalaciones() {

    this.apollo.watchQuery<any>({
      query: this.clienteService.getInstalacionesRedCliente(),
      variables: {
        "id": this.userLogged.cliente.id
      }
    })
      .valueChanges
      .subscribe(({ data, loading, errors }) => {
        this.instalacionService.setInstalaciones(data.cliente.instalaciones)
        this.router.navigate(['/cliente/instalaciones']);
      })
  }

}
